/**
 * @summary Contains the slider main area preact component.
 */

import { h } from 'preact';
import SliderSlide from './SliderSlide';
import SliderMainButton from './SliderMainButton';

/**
 * @summary Slider preact preact component.
 *
 * @param {Object} props Props passed to this component.
 * @param {Array} props.data List of slides.
 * @param {number} props.activeIndex The currently active item.
 * @param {function} props.setRef Function to reference to the main DOM element.
 * @param {function} props.handleButtonClick Event listener for click events on
 *                                           the navigation buttons.
 * @returns {JSX} The react component.
 */
export default function SliderMain({ data, activeIndex, setRef, handleButtonClick }) {
	const slides = data.map( item => {
		return <SliderSlide key={item.index} {...item} state={item.index - activeIndex}/>;
	});

	return (
		<div class="c-slider__main" ref={setRef} tabIndex="-1">
			{slides}

			<nav>
				<ul class="c-slider__navigation">
					<li class="c-slider__navigation-leaf">
						<SliderMainButton direction="left" handleClick={handleButtonClick} />
					</li>
					<li class="c-slider__navigation-leaf">
						<SliderMainButton direction="right" handleClick={handleButtonClick} />
					</li>
				</ul>
			</nav>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/js/components/SliderMain.js